module.exports = __webpack_public_path__ + "assets/img/Project_bgimg.8b119613.png";